module.exports = __webpack_public_path__ + "static/img/xingNo.cba97906.svg";